<template>
  <div></div>
</template>

<script>

// Home view is only used for redirecting. At least for now.

export default {
  name: 'Home',
  mounted() {
    const app = this;

    // Redirect to correct page
    if(app.$store.state.user.role === 'importer-admin' || app.$store.state.user.role === 'site-admin') {
      app.$router.replace({
        name: 'companies',
        params: {
          parent: this.$store.state.user.company.id
        }
      });
    }

    this.$store.commit('setSubheader', {
      subtitle: '',
      title: this.loc('components.home.subheaderTitle'),
      description: this.loc('components.home.subheaderDescription')
    });
  }
}
</script>
